/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { NewMapOptions } from "app/components/map/ui-models/new-map-options";
import { ServerSettingsService } from "app/services/server-settings.service";

@Injectable()
export class NewMapOptionsResolver implements Resolve<NewMapOptions> {

    constructor(
        private serverSettingsService: ServerSettingsService
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<NewMapOptions> {
        return this.serverSettingsService.getMapOptions();
    }

}
